import { render, staticRenderFns } from "./Basic_Theory.vue?vue&type=template&id=b2034704&scoped=true&"
import script from "./Basic_Theory.vue?vue&type=script&lang=js&"
export * from "./Basic_Theory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2034704",
  null
  
)

export default component.exports